export const API_ROOT = 'https://lhl-reco-api.herokuapp.com/api';
export const API_WS_ROOT = 'wss://lhl-reco-api.herokuapp.com/cable';
export const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};